class HeaderAnnouncementSlider {
    constructor(element) {
        this.element = element;
        this.slides = this.element.querySelectorAll('.toolbar__announcement-slide');
        this.currentSlide = 0;
        this.isAnimating = false;

        // Récupérer les options du customizer
        this.speed = parseFloat(this.element.dataset.sliderSpeed) * 1000 || 4000;
        this.effect = this.element.dataset.sliderEffect || 'fade';
        this.transitionDuration = parseInt(this.element.dataset.transitionDuration) || 800;

        if (this.slides.length > 1) {
            this.init();
        }
    }

    init() {
        this.setupSlider();
        this.startAutoSlide();
    }

    setupSlider() {
        // Ajouter la classe d'initialisation pour éviter le FOUC
        this.element.classList.add('slider-initialized');

        // Créer le container des slides
        const slidesContainer = document.createElement('div');
        slidesContainer.className = 'toolbar__announcement-slides';

        // Déplacer toutes les slides dans le container
        this.slides.forEach((slide, index) => {
            slide.classList.add('toolbar__announcement-slide');
            if (index === 0) {
                slide.classList.add('active');
            }
            slidesContainer.appendChild(slide);
        });

        // Remplacer le contenu original par le container
        this.element.innerHTML = '';
        this.element.appendChild(slidesContainer);

        // IMPORTANT: Récupérer les nouvelles références après avoir reconstruit la structure
        this.slides = this.element.querySelectorAll('.toolbar__announcement-slide');
    }

    startAutoSlide() {
        this.intervalId = setInterval(() => {
            this.nextSlide();
        }, this.speed);
    }

    nextSlide() {
        if (this.isAnimating) return;

        this.isAnimating = true;
        const currentSlideElement = this.slides[this.currentSlide];

        // Passage au slide suivant
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        const nextSlideElement = this.slides[this.currentSlide];

        // Animation de sortie de l'ancien texte
        currentSlideElement.classList.add('exiting');

        // Attendre que l'ancien texte soit complètement sorti avant d'afficher le nouveau
        setTimeout(() => {
            currentSlideElement.classList.remove('active', 'exiting');

            // Puis faire apparaître le nouveau texte après un petit délai
            setTimeout(() => {
                nextSlideElement.classList.add('active');
                this.isAnimating = false;
            }, 100); // Petit délai pour éviter le chevauchement
        }, this.transitionDuration * 0.5); // 50% du temps pour la sortie complète
    }

    destroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
}

// Initialisation
document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('[data-announcement-slider]');
    sliders.forEach(slider => {
        new HeaderAnnouncementSlider(slider);
    });
}); 